import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function usePhonecall(phonecallId) {
  const { data, isValidating, isLoading, mutate } = useSWR(
    phonecallId ? `/phonecalls/${phonecallId}` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default usePhonecall;
